// extracted by mini-css-extract-plugin
export default {"spinner_container":"assignee-cell_spinner_container__ctf-M","spinner_margin":"assignee-cell_spinner_margin__yWJsk"};